export default __webpack_public_path__ + "static/media/Group 2575@2x.754303bd.png";